<template>
  <LoginGuard>
    <router-view></router-view>
  </LoginGuard>
</template>

<script>
import LoginGuard from "../../../../vue-ocom/auth/components/LoginGuard.vue";

export default {
  components: {
    LoginGuard,
  },
  computed: {},
};
</script>
